import RadioButtonChecked from "@mui/icons-material/RadioButtonChecked"
import RadioButtonUnchecked from "@mui/icons-material/RadioButtonUnchecked"
import { Box, Stack, Theme, Typography } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { CurrencyCode } from "@shopify/hydrogen-react/storefront-api-types"
import { last } from 'lodash-es'
import React, { useMemo } from "react"
import { useAutomaticDiscountList } from "../../../../shared/hooks/useAutomaticDiscountList"
import useLoggedInCustomer from "../../../../shared/hooks/useLoggedInCustomer"
import { MoneyDisplay } from "../../moneyDisplay"
import { AddToCartMultiProps } from "../multi"

const cardBorderStyles = (theme: Theme, borderWidth?: number) => {
    return {
        borderStyle: 'solid', borderWidth: (borderWidth || 1) + 'px', borderColor: theme.palette.grey[400], borderRadius: '10px'
    }
}

type AddToCartCardProps = AddToCartMultiProps & {
    quantity: number
}

export type ProductPriceWithDiscount = {
    standardUnitPrice: number
    discountedUnitPrice: number
    discountPercent: number | null
    quantity: number
    currencyCode: CurrencyCode
}

export const AddToCartCard = ({ product, variantId, quantity, quantityDescription, selectedQuantity, setSelectedQuantity }: AddToCartCardProps) => {
    const theme = useTheme();

    const defaultVariant: typeof product.variants[0] = last(product.variants);
    const selectedVariant: typeof product.variants[0] = variantId ? product.variants.find(v => v.shopifyId === variantId) : defaultVariant

    const isSelected = selectedQuantity === quantity;
    const borderStyles = cardBorderStyles(theme, isSelected ? 3 : 1);
    const { wholesale } = useLoggedInCustomer();

    const { discountPriceForPrice } = useAutomaticDiscountList();

    const discountedUnitPrice = useMemo(() => {
        // if (wholesale) {
        //     return {
        //         amount: (selectedVariant.presentmentPrices[0].price.amount - ((getWholesaleDiscountPercent(quantity) / 100) * selectedVariant.presentmentPrices[0].price.amount)).toString(),
        //         currencyCode: selectedVariant.presentmentPrices[0].price.currencyCode as CurrencyCode
        //     }
        // }
        // else {
        return discountPriceForPrice(quantity, selectedVariant.presentmentPrices[0].price, quantity);
        // }
    }, [wholesale, variantId, selectedVariant.id]);

    return (
        <Box p={1} sx={{ ...borderStyles, width: '100%', cursor: 'pointer' }} onClick={() => setSelectedQuantity(quantity)}>
            <Stack direction={{ xs: 'column', sm: 'column', md: 'row' }} gap={{ xs: 1, sm: 1, md: 2 }} alignItems={'center'} justifyContent={'space-between'} sx={{ width: '100%' }}>
                <Stack direction='row' gap={2} alignItems={'center'} justifyContent={'flex-start'}>
                    {isSelected ? <RadioButtonChecked color='primary' /> : <RadioButtonUnchecked />}
                    <Typography variant='h4'>{quantity} {quantityDescription}{quantity > 1 ? 's' : ''}</Typography>
                    {/* {tag && <Chip label={tag} variant="filled" color='success' />} */}
                </Stack>

                <MoneyDisplay priceDirection={!wholesale ? 'row-reverse' : undefined} money={discountedUnitPrice} invertSaveDirection chipPrefix='Save ' quantity={wholesale ? 1 : quantity} valueSuffix={wholesale ? ' each' : undefined} nonDiscounted={selectedVariant.presentmentPrices[0].price} showSavePill savePillAsValue={!wholesale} direction='row' />
            </Stack>
        </Box>
    )
}

